import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const skillsRoute: InvariantJiraRoute = {
	name: 'servicedesk-skills',
	path: '/jira/servicedesk/projects/:projectKey/skills',
	exact: true,
};
